import { CaretDownFill, CaretRightFill, CaretUpFill } from "react-bootstrap-icons";
import { getRadioName, getSongScoreColorCss, toAutoDecimals } from "./HelperFunctions";
import { Suspense } from "react";
import { Await, useRouteLoaderData } from "react-router-dom";

export const renderSortIcon = (key, sortConfig) => sortConfig?.key === key && (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />);

export function renderTrendIcon(trend) {
    if (trend === 1) {
        return <CaretUpFill height={20} width={20} className="text-success" />;
    } else if (trend === 2) {
        return (
            <>
                <CaretUpFill height={20} width={20} className="text-success" />
                <CaretUpFill height={20} width={20} className="text-success" style={{ marginTop: -10 }} />
            </>
        );
    } else if (trend === -1) {
        return <CaretDownFill height={20} width={20} className="text-danger" />;
    } else if (trend === -2) {
        return (
            <>
                <CaretDownFill height={20} width={20} className="text-danger" />
                <CaretDownFill height={20} width={20} className="text-danger" style={{ marginTop: -10 }} />
            </>
        );
    } else if (trend === 0) {
        return <CaretRightFill height={20} width={20} className="text-secondary" />;
    }
}

export function renderScoreTrendIcon(trend) {
    if (trend > 0.5) {
        return <CaretUpFill height={20} width={20} className="text-success" />;
    } else if (trend < -0.5) {
        return <CaretDownFill height={20} width={20} className="text-danger" />;
    } else if (trend >= -0.5 && trend <= 0.5) {
        return <CaretRightFill height={20} width={20} className="text-secondary" />;
    }
}

export const renderSongScore = score => <span className={`score ${getSongScoreColorCss(score, true)}`}>{toAutoDecimals(score, 1)}</span>;

export const RadioName = ({ radioId, notFoundFallback = "Unknown", loadingFallback = "Loading" }) => {
    const { allRadioNames } = useRouteLoaderData("root");
    return (
        <Suspense fallback={loadingFallback}>
            <Await resolve={allRadioNames}>{resolvedRadios => getRadioName(radioId, resolvedRadios.data, notFoundFallback)}</Await>
        </Suspense>
    );
};
